import {
  TableData,
  TableHeaderCategoryConfig,
} from "../../../../components/tables/tableContext/TableContext";

import { DeliveredAwbHistoryDataInterface } from "../../../../redux/interfaces/expedition.interface";
import { getDateAndTime } from "../../../../utils/dateAndTime";

export const deliveredAwbHistoryTableHeader: TableHeaderCategoryConfig[] = [
  {
    label: "AWB",
    value: "doc_trans",
    minW: 125,
    withSearch: true,
  },
  {
    label: "Pct. preluare",
    value: "pctpreluare",
    minW: 125,
  },
  {
    label: "Pct. livrare",
    value: "pctlivrare",
    minW: 125,
    withSearch: true,
  },
  {
    label: "Adresa",
    value: "adresa",
    minW: 125,
  },
  {
    label: "Nod-Destinatie",
    value: "nodDestinatie",
    minW: 125,
  },
  {
    label: "Status",
    value: "status",
    minW: 125,
  },
  {
    label: "Tipul expedierii",
    value: "tip_colete",
    minW: 125,
  },
  {
    label: "Nota",
    value: "nota",
    minW: 125,
  },
  {
    label: "Data crearii",
    value: "data_crearii",
    minW: 125,
  },
  {
    label: "Data livrare",
    value: "ts_operatie",
    minW: 125,
  },
];

export const getDeliveredAwbHistoryTableData = (
  data: DeliveredAwbHistoryDataInterface[],
): TableData[] =>
  data.map((item) => {
    return {
      id: item.arh_doctrans,
      crudData: item,
      data: [
        {
          title: item.doc_trans,
        },
        {
          title: item.pctpreluare,
        },
        {
          title: item.pctlivrare,
        },
        {
          title: item.adresa,
        },
        {
          title: item.nodDestinatie,
        },
        {
          badges: [
            {
              badgeText: item.denumireStatus ?? "-",
              badgeColor: "light-info",
            },
          ],
        },
        {
          badges:
            item.tip_colete?.map((tip) => ({
              badgeText: `${tip.denumire} x ${tip.count_tip_ambalaj}`,
              badgeColor: "primary",
            })) ?? [],
        },
        {
          title: item.nota,
        },
        {
          badges: [
            {
              badgeText: item.data_crearii
                ? getDateAndTime(item.data_crearii)
                : "-",
              badgeColor: "light-info",
            },
          ],
        },
        {
          badges: [
            {
              badgeText: item.ts_operatie
                ? getDateAndTime(item.ts_operatie)
                : "-",
              badgeColor: "light-info",
            },
          ],
        },
      ],
    };
  });
